export class OutOfLimitsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "OutOfLimitsError";
  }
}
